import { MeetingOutcomeKeys } from './meeting-outcomes.enum';

export const MEETING_OUTCOMES_LOOKUP = [
  { value: MeetingOutcomeKeys.cancelled, description: 'Cancelled' },
  { value: MeetingOutcomeKeys.completed, description: 'Completed' },
  { value: MeetingOutcomeKeys.noShow, description: 'No Show' },
  { value: MeetingOutcomeKeys.rescheduled, description: 'Rescheduled' },
  { value: MeetingOutcomeKeys.schedules, description: 'Scheduled' },
];
